import React, { FC } from "react";
import { ReferenceField, useRecordContext } from "react-admin";
import DriverWithPhoneField from "./DriverWithPhoneField";
import Tooltip from "@material-ui/core/Tooltip";
import LoopIcon from "@material-ui/icons/Loop";
import { Box } from "@material-ui/core";

interface BusAssistantWithReplacementIconFieldProps {
  label: string;
}

const BusAssistantWithReplacementIconField: FC<
  BusAssistantWithReplacementIconFieldProps
> = () => {
  const record = useRecordContext();

  if (!record) return null;

  const hasReplacement = Boolean(record.replacedBusAssistantIdByAdhocOperator);

  return (
    <Box display="inline-flex" alignItems="center">
      <ReferenceField
        source="busAssistantId"
        reference="busAssistants"
        link="show"
        emptyText="-"
      >
        <DriverWithPhoneField />
      </ReferenceField>
      {hasReplacement && (
        <Tooltip
          title={`Replaced by Adhoc Bus Assistant`}
          style={{ marginLeft: "5px" }}
        >
          <LoopIcon fontSize="small" color="primary" />
        </Tooltip>
      )}
    </Box>
  );
};

export default BusAssistantWithReplacementIconField;
